import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_file = _resolveComponent("input-file")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrComponents, (compo, index) => {
      return (_openBlock(), _createElementBlock("div", { key: compo }, [
        _createVNode(_component_input_file, {
          onAdd_one: _ctx.atender_archivo,
          position: index,
          onFile_selected: _ctx.add_file,
          onRemove_one: _ctx.remove_file
        }, null, 8, ["onAdd_one", "position", "onFile_selected", "onRemove_one"])
      ]))
    }), 128))
  ]))
}